var n=function(t){return t.ATTENDANT="attendant",t.POST="post",t.PAGE="page",t.FAQ="faq",t}({});export{n as SearchGroup};